import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Scrollchor from 'react-scrollchor'
import trans from 'counterpart'
import moment from 'moment'
import { confirmReservation, nextSection } from '../../reservation/actions'
import { getBlocksOfType } from '../../../selectors/entitySelectors'

class BookingSectionSubmit extends Component {
  confirm = () => this.props.onConfirm()
    .then((result) => {
      if (!result) return false

      if (moment(this.props.arrivalDate, 'YYYY-MM-DD').subtract(28, 'days') < moment()) {
        return this.props.history.push(`${trans('routes.payment_request')}?resort=${result.resort_id}`)
      }
      return this.props.history.push(`${trans('routes.reservation_confirm')}?resort=${result.resort_id}`)
    })
    .catch((err) => {
      console.error(err)
    });

  next = () => this.props.onNextSection(this.props.sections);

  render = () => {
    const { arrivalDate, current } = this.props

    return (
      <>
        {current && current.name === 'personal_details_section' ? (
          <>
            {moment(arrivalDate, 'YYYY-MM-DD').subtract(28, 'days') < moment()
              ? <div className='alert alert-warning'>{trans('label.shortarrival_payment_choices')}</div>
              : <p>{trans('label.default_payment_choices')}</p>}
            <button
              className='btn btn-lg btn-primary-color btn-reset-lh text-heading-font'
              type='button'
              onClick={this.confirm}
              disabled={this.props.isConfirming}
            >
              {moment(arrivalDate, 'YYYY-MM-DD').subtract(28, 'days') < moment()
                ? trans('button.reservation_confirmation_and_pay')
                : this.props.properties.buttonLabel}
              <svg className={`spinner ml-1 ${this.props.isConfirming ? 'visible' : ''}`} width='20px' height='20px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>
                <circle className='path' fill='none' strokeWidth='15' strokeLinecap='round' cx='33' cy='33' r='30' />
              </svg>
            </button>
          </>
        ) : (
          <Scrollchor to='#booking' beforeAnimate={this.next}>
            <button
              className='btn btn-lg btn-reset-lh text-heading-font btn-main'
              type='button'
              disabled={this.props.isConfirming}
            >
              {this.props.properties.buttonLabel}
            </button>
          </Scrollchor>
        )}
      </>
    )
  }
}

BookingSectionSubmit.propTypes = {
  arrivalDate: PropTypes.string,
  current: PropTypes.object,
  history: PropTypes.object,
  isConfirming: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onNextSection: PropTypes.func.isRequired,
  properties: PropTypes.object.isRequired,
  sections: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
  isConfirming: state.reservation.isConfirming,
  current: state.reservation.sections.current,
  arrivalDate: state.reservation.arrival_date,
  sections: getBlocksOfType('BookingSection')(state)
})

const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(confirmReservation()),
  onNextSection: sections => dispatch(nextSection(sections))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingSectionSubmit))
